<template>
  <TableSkeleton v-if="loadingTableData" />
  <a-table
    v-else
    id="contacts-table"
    row-key="id"
    size="middle"
    :columns="columns"
    :data-source="contactsInfo.items"
    bordered
    :loading="loadingTableData"
    :scroll="scrollStyle"
    @change="handleTableChange"
    :pagination="pagination"
    :locale="locale"
    :row-selection="rowSelection"
  >
    <template #emptyText>
      <div class="filter__empty">
        <span>No se encontraron resultados. Por favor, pruebe modificando sus filtros.</span>
      </div>
    </template>

    <template #codContact="{ record }">
      <span>{{ record.code }}</span>
    </template>
    <template #fullName="{ record, text, index }">
      <div class="flex-center">
        <a
          @click.prevent="
            handleSelectClient({ index, clientId: record.id, tab: ClientInformationTabsKey.PersonalData })
          "
          >{{ text }}</a
        >
        <a-tooltip v-if="showInfoHubspot(record)">
          <template #title>
            {{ tooltipContactHubspot(record) }}
          </template>
          <HubspotIcon size="14" class="hubspot-icon"/>
        </a-tooltip>
        <a-tooltip v-if="showWarningHubspot(record) && !isAgentUser">
          <template #title>
            {{ tooltipWarningContactHubspot(record) }}
          </template>
          <WarningOutlined style="color: #FAAD14; margin-left: 4px" />
        </a-tooltip>
      </div>
    </template>

    <template #status="{ record, text }">
      <a-tag v-if="record.status === ContactStatus.Active" color="green">Activo</a-tag>
      <a-tag v-if="record.status === ContactStatus.Inactive">Inactivo</a-tag>
    </template>

    <template #baseName="{ record, text }">
      <span v-if="text.length > 0">{{ record.baseName }}</span>
      <span v-else> -- </span>
    </template>

    <template #titleBases>
      <span> Bases </span>
    </template>

    <template #phones="{ record, text, index }">
      <a
        @click.prevent="
          handleSelectClient({ index, clientId: record.id, tab: ClientInformationTabsKey.Phones })
        "
      >
        <a-popover v-if="text.length > 0">
          <template #title>
            <span
              >{{ text.length }}
              {{ text.length > 1 ? "teléfonos" : "teléfono" }}
            </span>
          </template>
          <template #content>
            <ul class="list">
              <li v-for="phone in text" :key="phone" class="phone">
                {{ phone }}
              </li>
            </ul>
          </template>
          {{ text.length }}
          {{ text.length > 1 || text.length === 0 ? "teléfonos" : "teléfono" }}
        </a-popover>
        <span v-if="text.length === 0">0 teléfonos</span>
      </a>
    </template>

    <template #total_accounts="{ record, text, index }">
      <a
        v-if="text"
        @click.prevent="
          handleSelectClient({ index, clientId: record.id, tab: ClientInformationTabsKey.PersonalData })
        "
      >
        {{ text }}
        {{ text > 1 ? "productos" : "producto" }}
      </a>
      <span v-else class="placeholder">Sin productos</span>
    </template>

    <template #queues="{ text }">
      <a>
        <a-popover v-if="text.length > 0">
          <template #title>
            <span> {{ text.length }} {{ text.length > 1 ? "colas" : "cola" }} </span>
          </template>
          <template #content>
            <ul class="list">
              <li v-for="queue in text" :key="queue.id">{{ queue.name }}</li>
            </ul>
          </template>
          {{ text.length }}
          {{ text.length > 1 || text.length === 0 ? "colas" : "cola" }}
        </a-popover>
        <span v-if="text.length === 0">0 colas</span>
      </a>
    </template>

    <template #sequence_name="{ record }">
      <span>{{ record.sequence_name ? record.sequence_name : "Sin secuencia" }}</span>
    </template>
    <template #sequence_status="{ record }">
      <div v-if="record?.sequence_status">
        <a-tag :color="record.sequence_status === SequenceStatus.Active ? 'green' : undefined">
          {{ record.sequence_status === SequenceStatus.Active ? "Activa" : "Inactivo" }}
        </a-tag>
      </div>
      <div v-else>
        <span>Sin secuencia</span>
      </div>
    </template>
    <template #state_in_sequence="{ record }">
      <span>{{
        record.state_in_sequence ? getSequenceState(record.state_in_sequence) : "Sin secuencia"
      }}</span>
    </template>

    <template #emails="{ record, text, index }">
      <a
        @click.prevent="
          handleSelectClient({ index, clientId: record.id, tab: ClientInformationTabsKey.Emails })
        "
      >
        <a-popover v-if="text.length > 0">
          <template #title>
            <span>{{ text.length }} correos</span>
          </template>
          <template #content>
            <ul>
              <li v-for="email in text" :key="email">{{ email }}</li>
            </ul>
          </template>
          {{ text.length }} correos
        </a-popover>
        <span v-if="text.length === 0">0 correos</span>
      </a>
    </template>

    <template #customTitleLastManagementDate>
      Fecha de última gestión
      <!-- <SwapOutlined :rotate="90" /> -->
    </template>

    <template #titleLastInteractionDate>
      Fecha de última interacción
      <!-- <SwapOutlined :rotate="90" /> -->
    </template>

    <template #channels="{ text }">
      <div class="channels">
        <div v-for="item in uniqueChannel(text)" :key="item[0]">
          <img :src="item.icon" alt="icono" />
        </div>
      </div>
    </template>

    <template #lastManagementDate="{ text }">
      <span v-if="text.length > 3"> {{ formatDate(text) }} </span>
      <span v-else> {{ text }} </span>
    </template>

    <template #lastInteractionDate="{ text }">
      <span v-if="text.length > 3"> {{ formatDate(text) }} </span>
      <span v-else> {{ text }} </span>
    </template>

    <template #headerCell="{ column, title }">
      <template v-if="column.dataIndex === 'whatsapp_username' || column.key === 'whatsapp_username'">
        <span class="table-header-with-tooltip">
          {{ title }}
          <a-tooltip title="Nombre de usuario que el contacto tiene configurado en WhatsApp">
            <InfoCircleOutlined class="header-info-icon" />
          </a-tooltip>
        </span>
      </template>
      <template v-else-if="column.dataIndex === 'whatsapp_user_id' || column.key === 'whatsapp_user_id'">
        <span class="table-header-with-tooltip">
          {{ title }}
          <a-tooltip title="Identificador único que WhatsApp asigna al contacto dentro de cada Business Manager.">
            <InfoCircleOutlined class="header-info-icon" />
          </a-tooltip>
        </span>
      </template>
      <template v-else-if="column.slots?.title === 'titleBases' || column.key === 'baseName'">
        <span> Bases </span>
      </template>
      <template v-else>
        <span>{{ title }}</span>
      </template>
    </template>

    <template #whatsappUsername="{ record }">
      <template v-if="getWhatsappUsernamesInfo(record).totalCount > 1">
        <a-space :size="8" align="center">
          <span>{{ getWhatsappUsernamesInfo(record).totalCount }} usuarios</span>
          <a-tooltip color="white">
            <InfoCircleOutlined :style="{ fontSize: '12px' }" />
            <template #title>
              <div class="calls-tooltip">
                <h4>{{ getWhatsappUsernamesInfo(record).totalCount }} Nombres de usuario</h4>
                <ul>
                  <li v-for="(u, index) in getWhatsappUsernamesInfo(record).list" :key="index">
                    <span class="channel-info">{{ formatWhatsappUsername(u) }}</span>
                  </li>
                </ul>
              </div>
            </template>
          </a-tooltip>
        </a-space>
      </template>
      <span v-else-if="getWhatsappUsernamesInfo(record).totalCount === 1">
        {{ formatWhatsappUsername(getWhatsappUsernamesInfo(record).list[0]) }}
      </span>
      <span v-else></span>
    </template>

    <template #whatsappUserId="{ record }">
      <template v-if="getWhatsappUserIdsInfo(record).totalCount > 1">
        <a-space :size="8" align="center">
          <span>{{ getWhatsappUserIdsInfo(record).totalCount }} IDs de WhatsApp</span>
          <a-tooltip color="white">
            <InfoCircleOutlined :style="{ fontSize: '12px' }" />
            <template #title>
              <div class="calls-tooltip">
                <h4>{{ getWhatsappUserIdsInfo(record).totalCount }} IDs de WhatsApp asociados</h4>
                <ul>
                  <li v-for="(uid, index) in getWhatsappUserIdsInfo(record).list" :key="index">
                    <span class="channel-info">{{ uid }}</span>
                  </li>
                </ul>
              </div>
            </template>
          </a-tooltip>
        </a-space>
      </template>
      <span v-else-if="getWhatsappUserIdsInfo(record).totalCount === 1">
        {{ getWhatsappUserIdsInfo(record).list[0] }}
      </span>
      <span v-else></span>
    </template>

    <template #actions="{ record, index }">
      <span class="actions-cell" id="strategy-actions">
        <a-popover placement="leftTop" class="actions-popover" v-model:open="openOptionsPopover[index]">
          <template #content>
            <a-button
              block
              type="text"
              class="table-cell__actions-btn"
              @click="
                handleSelectClient({
                  index,
                  clientId: record.id,
                  tab: ClientInformationTabsKey.PersonalData,
                })
              "
            >
              <p>Editar información</p>
            </a-button>
            <a-button
              block
              type="text"
              class="table-cell__actions-btn"
              v-if="record.status == ContactStatus.Active && getUserData?.profile !== ProfileTypes.Agent"
              @click="validationIsCallActive(record, index)"
            >
              <p>Inactivar contacto</p>
            </a-button>
            <a-button
              block
              type="text"
              class="table-cell__actions-btn"
              v-if="record.status == ContactStatus.Inactive && getUserData?.profile !== ProfileTypes.Agent"
              @click="
                visibleAlertChangeStatusContact = true;
                recordSelected = record;
              "
            >
              <p>Activar contacto</p>
            </a-button>
            <template v-if="record.status == ContactStatus.Active && getUserData?.profile !== ProfileTypes.Agent">
              <a-tooltip placement="left">
                <template #title v-if="!hasContactPhones(record)">
                  El contacto necesita mínimo un número de teléfono para ser asignado a secuencias.
                </template>
                <span class="disabled-action-wrapper">
                  <a-button
                    block
                    type="text"
                    :disabled="!hasContactPhones(record)"
                    class="table-cell__actions-btn"
                    @click="handleManageSequence(record, index)"
                  >
                    <p>Gestionar secuencias 
                      <a-tag
                        v-if="!hasSequence"
                        :color="ActionPlanStrategyColor[ActionPlanStrategy.Upgrade]"
                      >
                        {{ ActionPlanStrategyText[ActionPlanStrategy.Upgrade] }}
                      </a-tag>
                    </p>
                  </a-button>
                </span>
              </a-tooltip>
            </template>
            <a-button
              block
              type="text"
              class="table-cell__actions-btn"
              @click="handleConfirmExport(record, index)"
              v-if="!showInfoHubspot(record) && hasHubspotExportManual && !isAgentUser"
            >
              <p class="hubspot-button">
                <HubspotIcon size="15" color="#000000" /> Exportar a Hubspot
              </p>
            </a-button>
            <a-button
              block
              type="text"
              class="table-cell__actions-btn"
              @click="handleConfirmUpdateHubspot(record, index)"
              v-else-if="showWarningHubspot(record) && !isAgentUser"
            >
              <p class="hubspot-button">
                <HubspotIcon size="15" color="#000000" /> Actualizar a Hubspot
              </p>
            </a-button>
          </template>
          <a-button type="text"><MoreOutlined /></a-button>
        </a-popover>
      </span>
    </template>
  </a-table>
  <ManagerSequence
    :visible="visibleManagerSequence"
    @close="visibleManagerSequence = false"
    :record="recordSelected"
    :item-id="itemId"
  />

  <ChangeStatusContactModal
    v-if="visibleAlertChangeStatusContact"
    :record="recordSelected"
    :itemId="recordSelected?.id"
    :status="
      recordSelected.status == ContactStatus.Active ? ContactStatus.Inactive : ContactStatus.Active
    "
    @onCancel="visibleAlertChangeStatusContact = false"
  />

  <DeleteContactCallActiveModal
    :record="recordSelected"
    v-if="visibleAlertInactiveContactInCall"
    @onCancel="visibleAlertInactiveContactInCall = false"
    :itemId="recordSelected?.id"
    :contact="recordSelected"
  />

  <RestrictionChangePlanModal
    title="Realiza un upgrade y accede a todo el poder de Beex."
    :planRequest="PlanType.AllInOne"
    v-model:open="openRestriction"
  >
    <template #description>
      Tu plan {{ PlanTypeText[plan] }} no incluye esta funcionalidad.
      Solicita un upgrade y potencia tu ambiente de trabajo. 
      ¡Que tu viaje no se detenga!
    </template>
  </RestrictionChangePlanModal>

  <HubspotExportConfirmModal 
    v-if="visibleConfirmExport" 
    :open="visibleConfirmExport" 
    :type="actionHubspot"
    :contact="recordSelected" 
    :contactsId="[recordSelected.id]"
    :loadingSave="loadingSaveHubspot"
    @onCancel="visibleConfirmExport = false" 
    @onConfirm="handleExportHubspot(recordSelected.id)"
  />
</template>
<script>
import { defineComponent, computed, inject, watch, nextTick, ref, onMounted } from "vue";
import { useStore } from "vuex";
// import { SwapOutlined } from "@ant-design/icons-vue";
import { SequenceStatus } from "@/@types/flows/sequences";
import { SequenceStateText } from "@/app/flows/sequences/utils/texts.ts";
import ManagerSequence from "@/app/contacts/components/modal/ManagerSequence.vue";
import ChangeStatusContactModal from "@/app/contacts/components/modal/ChangeStatusContactModal.vue";
import DeleteContactCallActiveModal from "@/app/contacts/components/modal/DeleteContactCallActiveModal.vue";
import { getWalletsTableColumns } from "@/app/contacts/constants";
import { humanDateWithSlashFormat } from "@/app/shared/utils/constants";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { dateToString } from "@/app/shared/utils/dates";
import { DialingType, RolTypes } from "@/app/shared/utils/enums";
import EventBus from "@/app/shared/utils/eventBus";
import { ClientInformationTabsKey } from "@/app/contacts/utils/enums";
import { MoreOutlined, WarningOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";
import { ContactStatus } from "@/app/contacts/utils/enums";
import { updateContactHubspot, updateStatusContact } from "@/app/contacts/services";
import { message } from "ant-design-vue";
import { confirmIsCallUser } from "@/app/contacts/services";
import { ProfileTypes } from "@/app/shared/utils/enums";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";
import { PlanType, PlanTypeText } from "@/app/common/types";
import { ActionPlanStrategyColor, ActionPlanStrategyText, ActionPlanStrategy } from "@/app/common/utils/enums";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import HubspotIcon from "@/app/integrations/components/icons/HubspotIcon.vue";
import HubspotExportConfirmModal from "@/app/integrations/components/modals/HubspotExportConfirmModal.vue"
import { exportContactHubspot } from "@/app/contacts/services";
import httpManager from "@/app/shared/utils/httpManager";
import { HubspotIntegrationType } from "@/app/integrations/utils/enums";
import TableSkeleton from "@/app/shared/components/skeletons/TableSkeleton.vue";
import { IntegrationMode, IntegrationModeNumber } from "../../../integrations/utils/enums";

export default defineComponent({
  setup(props) {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    // const columns = getWalletsTableColumns(user.value?.customer?.enable_bases);
    const showBanner = inject("showBanner");
    const loadingTableData = inject("loadingTableData");
    const headerHeight = computed(() => (showBanner?.value ? 370 : 330));
    const openOptionsPopover = ref([]);

    const selectedTableRowKeys = inject("selectedTableRowKeys");
    const selectedHubspotExportRowKeys = inject("selectedHubspotExportRowKeys");
    const selectedHubspotResyncRowKeys = inject("selectedHubspotResyncRowKeys");
    // const selectedTableRowKeysMassive = inject("selectedTableRowKeysMassive");
    const updateSelectedTableRowKeys = inject("updateSelectedTableRowKeys");
    const rowsListMassive = inject("rowsListMassive");
    const selectedAll = inject("selectedAll");
    
    const currentPage = computed(() => store.getters["getCurrentTablePage"]);
    console.log(currentPage.value, "currentPage.value");

    const { scrollStyle, onResize, setNewMargin } = useScrollResize({
      headerHeight: headerHeight.value,
    });

    const hasHubspotImport = computed(() => {
      return store.getters.hasHubspotByCode(HubspotIntegrationType.Import);
    });
    const hasHubspotExport = computed(() => {
      return store.getters.hasHubspotByCode(HubspotIntegrationType.Export);
    });
    const hasHubspotExportManual = computed(() => {
      const functionality = store.getters.getHubspotByCode(HubspotIntegrationType.Export);
      if (functionality)
        return functionality.mode == IntegrationModeNumber[IntegrationMode.Manual];
      return false;
    })

    const showWarningHubspot = (record) => {
      return (record.resync_hubspot?.export && record.hubspot_export && hasHubspotExport.value) || 
        (record.resync_hubspot?.import && record.hubspot_import && hasHubspotImport.value)
    };

    watch(headerHeight, (newHeaderHeight) => setNewMargin(newHeaderHeight), { immediate: true });

    const selectedRowKeys = ref([]);

    const dataPlan = computed(() => store.getters["getDataPlanDetails"]);
    const plan = computed(() => user.value?.change_custom_plan?.plan);
    const openRestriction = ref(false);

    const hasSequence = computed(() => {
      return ![PlanType.Voice, PlanType.Digital, PlanType.DigitalVoice].includes(dataPlan.value?.plan);
    });

    const rowSelection = {
      selectedRowKeys: computed(() => selectedTableRowKeys.value), // computed(() => selectedTableRowKeys.value),
      onChange: async (selectedRowKeys, selectedRows) => {
        let rowsPageKeysSet = new Set();

        if (selectedTableRowKeys.value == 0) {
          selectedTableRowKeys.value = selectedRowKeys;

          // Seleccion para exportar a Hubspot
          if (hasHubspotExport.value) {
            selectedHubspotExportRowKeys.value = selectedRows
              .filter(row => row.hubspot_id === null)
              .map(row => row.key);
          }

          // Seleccion para actualizar contactos con Hubspot
          if (hasHubspotImport.value || hasHubspotExport.value) {
            selectedHubspotResyncRowKeys.value = selectedRows
              .filter(row => showWarningHubspot(row))
              .map(row => row.key);
          }
        } else {
          if (rowsListMassive.value.length == 0) {
            rowsListMassive.value = props.contactsInfo.items.map((el) => ({
              key: el.key,
              page: currentPage.value,
              status: el.status,
              hubspot_id: el.hubspot_id,
            }));
          }
          await nextTick();
          const rowsPageKeysSet = new Set(
            rowsListMassive.value
              .filter((row) => row.page === currentPage.value)
              .map((el) => el.key)
          );

          selectedTableRowKeys.value = [
            ...selectedTableRowKeys.value.filter((key) => !rowsPageKeysSet.has(key)),
            ...selectedRowKeys,
          ];

          // Seleccion para exportar a Hubspot
          if (hasHubspotExport.value) {
            const selectedPageHubspotKeys = selectedRows
              .filter(row => row.hubspot_id === null)
              .map(row => row.key);

            selectedHubspotExportRowKeys.value = [
              ...selectedHubspotExportRowKeys.value.filter(
                key => !rowsPageKeysSet.has(key)
              ),
              ...selectedPageHubspotKeys,
            ];
          }

          // Seleccion para actualizar contactos con Hubspot
          if (hasHubspotImport.value || hasHubspotExport.value) {
            const selectedPageHubspotRefreshKeys = selectedRows
              .filter(row => showWarningHubspot(row))
              .map(row => row.key);

            selectedHubspotResyncRowKeys.value = [
              ...selectedHubspotResyncRowKeys.value.filter(
                key => !rowsPageKeysSet.has(key)
              ),
              ...selectedPageHubspotRefreshKeys,
            ];
          }
        }
      },
      onSelectAll: (selected, selectedRows) => {
        selectedAll.value = selected;
      },
    };

    return {
      ClientInformationTabsKey,
      // columns,
      user,
      headerHeight,
      loadingTableData,
      scrollStyle,
      onResize,
      rowSelection,
      ContactStatus,
      rowsListMassive,
      SequenceStatus,
      ProfileTypes,
      hasSequence,
      plan,
      openRestriction,
      ActionPlanStrategyColor,
      ActionPlanStrategyText,
      ActionPlanStrategy,
      PlanType,
      PlanTypeText,
      openOptionsPopover,
      selectedHubspotExportRowKeys,
      selectedHubspotResyncRowKeys,
      hasHubspotImport,
      hasHubspotExport,
      hasHubspotExportManual,
      showWarningHubspot,
    };
  },
  components: {
    // SwapOutlined,
    ManagerSequence,
    MoreOutlined,
    ChangeStatusContactModal,
    DeleteContactCallActiveModal,
    RestrictionChangePlanModal,
    HubspotIcon,
    HubspotExportConfirmModal,
    WarningOutlined,
    InfoCircleOutlined,
    TableSkeleton,
  },
  props: {
    contactsInfo: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    itemId: {
      required: false,
      type: Number || String,
      default: "",
    },
  },
  data() {
    return {
      // scrollStyle: { x: 2800, y: 500 },
      contactEmpty: false,
      // locale: {
      //   emptyText: `<div class="filter__empty">
      //       <span>No se encontraron resultados. Por favor, pruebe modificando sus filtros.</span>
      //     </div>`,
      // },
      recordSelected: null,
      visibleAlertChangeStatusContact: false,
      visibleAlertInactiveContactInCall: false,
      visibleManagerSequence: false,
      visibleConfirmExport: false,
      actionHubspot: null,
      loadingSaveHubspot: false,
    };
  },
  watch: {
    contactsInfo: {
      handler() {
        this.$nextTick(() => {
          console.log(this.contactsInfo, "this.contactsInfo");
          this.contactsInfo.items?.forEach((_, index) => {
            this.openOptionsPopover[index] = false;
          });
          console.log(this.openOptionsPopover, "this.openOptionsPopover")
        });
      },
      deep: true,
    },
  },
  computed: {
    getUserData() {
      return this.$store.getters["getDataUser"];
    },
    isAgentUser() {
      return this.getUserData?.role?.id === RolTypes.agent;
    },
    basicFilters() {
      return this.$store.getters["getBasicFilters"];
    },
    advancedFilters() {
      return this.$store.getters["getAdvancedFilters"];
    },
    currentPage() {
      return this.$store.getters["getCurrentTablePage"];
    },
    pagination() {
      return {
        ...this.contactsInfo.pagination,
        current: this.currentPage,
        showSizeChanger: false,
      };
    },
    tagConnectionCall() {
      return this.$store.getters["getTagConnectionCall"];
    },
  },

  async created() {
    this.$store.commit("SET_CURRENT_TABLE_PAGE", 1);
    this.$store.commit("SET_ADVANCED_FILTERS", {});
    this.$store.commit("SET_ADVANCED_FILTER", {});
    this.$store.commit("SET_BASIC_FILTERS", {});
    await this.handleFetchContacts(this.pagination);
    this.rowsListMassive = this.contactsInfo.items.map((el) => ({
      key: el.key,
      page: 1,
      status: el.status,
    }));
    console.log(this.rowsListMassive);
    // this.handleProgressiveInProgress();
    EventBus.on("FILTERS_CONTACTS_EMPTY", (data) => {
      this.contactEmpty = data;
    });
  },
  // mounted() {
  //   window.addEventListener("resize", this.onResize);
  //   this.scrollStyle = { x: 2800, y: window.innerHeight - this.headerHeight };
  // },
  // beforeUnmount() {
  //   window.removeEventListener("resize", this.onResize);
  // },
  methods: {
    // onResize() {
    //   this.scrollStyle = { x: 2800, y: window.innerHeight - this.headerHeight };
    // },
    async handleExportHubspot(idContact) {
      try {
        this.loadingSaveHubspot = true;
        if (this.actionHubspot === 'export') {
          const response = await exportContactHubspot(idContact);
          message.success("Contacto exportado a HubSpot con éxito.");
        } else {
          const response = await updateContactHubspot(idContact);
          message.success("Contacto actualizado con Hubspot exitosamente.");
        }
        await this.handleFetchContacts(this.pagination);
      } catch(error) {
        message.error(error?.getErrorMessage?.());
      } finally {
        this.visibleConfirmExport = false;
        this.loadingSaveHubspot = false;
      }
    },
    // hasHubspotByCode(code) {
    //   const hub = this.getUserData?.customer?.hubspot_data;

    //   if (!hub || hub.state !== 1) return false;

    //   return (
    //     hub.functionalities?.some(
    //       f => f.code === code && f.active === true
    //     ) ?? false
    //   );
    // },
    showInfoHubspot(record) {
      return (record.hubspot_export && this.hasHubspotExport) || 
        (record.hubspot_import && this.hasHubspotImport)
    },
    tooltipWarningContactHubspot(record) {
      return record.hubspot_export ? 
        'Se han detectado cambios desde BeexCC. Actualiza para exportar cambios o nuevos datos homologados a HubSpot.' :
        record.hubspot_import ?
        'Se han detectado cambios desde Hubspot. Actualiza para importar cambios o nuevos datos homologados a BeexCC.' :
        ''
    },
    tooltipContactHubspot(record) {
      return record.hubspot_export ? 'Contacto exportado a HubSpot' :
        'Contacto importado desde HubSpot'
    },
    handleSelectClient({ index, clientId, tab = ClientInformationTabsKey.PersonalData } = {}) {
      this.$emit("onClientSelectId", { clientId, tab });
      this.openOptionsPopover[index] = false;
    },
    async handleTableChange(pagination) {
      await this.handleFetchContacts(pagination);
      this.$store.commit("SET_CURRENT_TABLE_PAGE", pagination.current);
      const index = this.rowsListMassive.findIndex((el) => el.page == pagination.current);
      console.log(this.rowsListMassive, "this.rowsListMassive");
      console.log(
        this.contactsInfo.items.map((el) => ({
          key: el.key,
          page: pagination.current,
          status: el.status,
        })),
        "this.contactsInfo.items.map(el => ({ ...el, page: pagination.current }))"
      );
      if (index == -1) {
        this.rowsListMassive = [
          ...this.rowsListMassive,
          ...this.contactsInfo.items.map((el) => ({
            key: el.key,
            page: pagination.current,
            status: el.status,
          })),
        ];
      }
      console.log(this.rowsListMassive, "this.rowsListMassive");
    },
    resetCurrentPage() {
      this.currentPage = 1;
    },
    async handleFetchContacts(pagination) {
      this.loadingTableData = true;

      if (
        this.advancedFilters.groups?.length > 0 &&
        this.basicFilters.campaign &&
        this.basicFilters.coverage === "True"
      ) {
        await this.$store.dispatch("applyAdvancedFilters", {
          filters: this.advancedFilters,
          pagination,
        });
      } else {
        await this.$store.dispatch("fetchContacts", { filters: this.basicFilters, pagination });
      }

      // if (Object.keys(this.advancedFilters).length === 0) {
      //   await this.$store.dispatch("fetchContacts", { filters: this.basicFilters, pagination });
      // } else {
      //   await this.$store.dispatch("applyAdvancedFilters", {
      //     filters: this.advancedFilters,
      //     pagination,
      //   });
      // }
      this.loadingTableData = false;
    },
    async handlePhoneClick(contact, number) {
      this.$store.commit("SET_DIALING_TYPE", 1);
      this.$jssip.clearData();
      await this.$jssip.call(number, DialingType.Manual, this.getUserData.id, contact.id);
      this.$store.dispatch("setCallFinish", false);
    },
    formatDate(date) {
      return dateToString(date, humanDateWithSlashFormat);
    },
    // handleProgressiveInProgress() {
    //   setTimeout(() => {
    //     if (this.tagConnectionCall?.status) {
    //       this.$router.push("/workspace");
    //     }
    //   }, 1000);
    // },
    uniqueChannel(text) {
      const uniqueGroup = [];
      text.forEach((typification) => {
        const elementAdded = uniqueGroup.find((u) => u.id === typification.id);
        if (!elementAdded) {
          uniqueGroup.push(typification);
        }
      });
      return uniqueGroup.map((item) => item);
    },

    async validationIsCallActive(record, index) {
      const response = await confirmIsCallUser({
        client: record?.id,
      });
      // this.isCallInactiveModal = true;
      if (response.detail === "Este cliente tiene una llamada en curso.") {
        this.visibleAlertInactiveContactInCall = true;
      } else {
        this.visibleAlertChangeStatusContact = true;
        this.recordSelected = record;
      }
      this.openOptionsPopover[index] = false;
    },
    getSequenceState(State) {
      if (!State) return "desconocido";
      return SequenceStateText[State];
    },
    getWhatsappUsernamesInfo(record) {
      const source = record?.whatsapp_username;
      const list = [];
      if (Array.isArray(source)) {
        source.forEach((u) => {
          if (u && !list.includes(String(u).trim())) list.push(String(u).trim());
        });
      } else if (source && String(source).trim()) {
        list.push(String(source).trim());
      }
      return {
        list,
        totalCount: list.length,
      };
    },
    getWhatsappUserIdsInfo(record) {
      const source = record?.whatsapp_user_id;
      const list = [];
      if (Array.isArray(source)) {
        source.forEach((uid) => {
          if (uid && !list.includes(String(uid).trim())) list.push(String(uid).trim());
        });
      } else if (source && String(source).trim()) {
        list.push(String(source).trim());
      }
      return {
        list,
        totalCount: list.length,
      };
    },
    formatWhatsappUsername(username) {
      if (!username) return "";
      const trimmed = String(username).trim();
      if (!trimmed) return "";
      return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
    },
    hasContactPhones(record) {
      if (!record) return false;
      const phones = record.phones;
      if (Array.isArray(phones) && phones.length > 0) {
        const validPhones = phones.filter((p) => {
          if (!p) return false;
          if (typeof p === "object") {
            const pVal = p.phone || p.number || "";
            return String(pVal).trim().length > 0 && String(pVal).trim() !== "--" && String(pVal).trim() !== "-";
          }
          const str = String(p).trim();
          return str.length > 0 && str !== "--" && str !== "-" && str !== "null" && str !== "undefined";
        });
        if (validPhones.length > 0) return true;
      }
      if (record.phone && typeof record.phone === "string") {
        const str = record.phone.trim();
        if (str.length > 0 && str !== "--" && str !== "-") return true;
      }
      if (record.phone_contact && typeof record.phone_contact === "string") {
        const str = record.phone_contact.trim();
        if (str.length > 0 && str !== "--" && str !== "-") return true;
      }
      return false;
    },
    handleManageSequence(record, index) {
      if (!this.hasContactPhones(record)) {
        this.openOptionsPopover[index] = false;
        return;
      }
      if (!this.hasSequence) {
        this.openRestriction = true;
        this.openOptionsPopover[index] = false;
        return;
      }
      this.visibleManagerSequence = true;
      this.recordSelected = record;
      this.openOptionsPopover[index] = false;
    },
    handleConfirmExport(record, index){
      this.visibleConfirmExport = true;
      this.recordSelected = record;
      this.actionHubspot = 'export';
    },
    handleConfirmUpdateHubspot(record, index){
      this.visibleConfirmExport = true;
      this.recordSelected = record;
      if (record.hubspot_export)
        this.actionHubspot = 'update-export';
      else
        this.actionHubspot = 'update-import';
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-table-thead > tr)
  background-color: $gray-2

img
  width: 17.37px
  margin-left: 5px
  margin-right: 10px

a
  font-size: 14px
  font-weight: 400

.list
  padding-left: 28px

.phone
  cursor: pointer

.base__name
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  display: block

// :deep(.ant-table-thead > tr > th .ant-table-column-sorter)
//   display: none

// :deep(.ant-table-body)
//   max-height: none !important

.channels
  display: flex

.placeholder
  color: $gray-5

.actions-cell
  display: flex
  align-items: center
  gap: 8px

.actions-popover.ant-btn
  padding: 5px
  display: flex
  flex-direction: column
  justify-content: center

  .anticon
    font-size: 16px
.hubspot-button
  display: flex
  align-items: center
  gap: 8px

.hubspot-icon
  margin-left: 5px

.flex-center
  display: flex
  align-items: center

.disabled-action-wrapper
  cursor: not-allowed
  width: 100%
  display: block

  .ant-btn[disabled]
    pointer-events: auto !important
    cursor: not-allowed !important
    color: rgba(0, 0, 0, 0.25) !important

    p
      color: rgba(0, 0, 0, 0.25) !important

.table-header-with-tooltip
  display: inline-flex
  align-items: center
  white-space: nowrap
  gap: 4px

  .header-info-icon
    font-size: 14px
    color: #8c8c8c
    flex-shrink: 0

.calls-tooltip
  color: black
  width: fit-content
  ul
    margin: 0
    padding-left: 20px
    li
      white-space: nowrap
      .channel-info
        color: black

@import '@/app/shared/assets/table-cell-actions.sass'
</style>

<style>
.filter__empty {
  text-align: center;
  font-size: 20px;
  color: #bfbfbf;
  padding-top: 200px;
  padding-bottom: 200px;
}
</style>
